export default "https://cdn-static.gokick.com/assets/7618e3e921e472ff268b4a806e404f75ad5d1010/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";